module.exports = __webpack_public_path__ + "img/kleisma4-m@1.8f56368c.webp";